import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './RotatingWord.css';

/**
 * RotatingWord
 * Cycles through `words` on its own, sliding the old word out and the new
 * one in - the self-changing headline from the reference ("...for your
 * Transactions" -> "...Wallet" -> "...NFTs" etc). Pauses permanently on a
 * single word if the user prefers reduced motion.
 */
export default function RotatingWord({ words, interval = 2200 }) {
  const [index, setIndex] = useState(0);
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    setReduceMotion(window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }, []);

  useEffect(() => {
    if (reduceMotion) return undefined;
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % words.length);
    }, interval);
    return () => clearInterval(id);
  }, [words.length, interval, reduceMotion]);

  return (
    <span className="rotating-word">
      <AnimatePresence mode="wait">
        <motion.span
          key={words[index]}
          className="rotating-word__item gradient-text"
          initial={reduceMotion ? false : { y: 24, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={reduceMotion ? undefined : { y: -24, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
        >
          {words[index]}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}
